import { render, staticRenderFns } from "./consultas.vue?vue&type=template&id=35d15eaa&scoped=true"
import script from "./consultas.vue?vue&type=script&lang=js"
export * from "./consultas.vue?vue&type=script&lang=js"
import style0 from "./consultas.vue?vue&type=style&index=0&id=35d15eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d15eaa",
  null
  
)

export default component.exports